import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useComments } from '@/hooks/useComments';
import { CommentForm } from './CommentForm';
import { CommentList } from './CommentList';

interface CommentsProps {
  postId: string;
}

export const Comments: React.FC<CommentsProps> = ({ postId }) => {
  const { comments, loading, error, addComment } = useComments(postId);

  if (loading) {
    return (
      <div className="glass p-6">
        <div className="flex items-center space-x-2 mb-6">
          <MessageCircle className="w-5 h-5 text-neon-green" />
          <h3 className="text-xl font-bold">Comments</h3>
        </div>
        <div className="text-center text-gray-400 py-8 animate-pulse">
          Loading comments...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="glass p-6">
        <div className="flex items-center space-x-2 mb-6">
          <MessageCircle className="w-5 h-5 text-red-500" />
          <h3 className="text-xl font-bold">Comments</h3>
        </div>
        <div className="text-center text-red-500 py-8">
          Failed to load comments. Please try again later.
        </div>
      </div>
    );
  }

  return (
    <div className="glass p-6 space-y-6">
      <div className="flex items-center space-x-2">
        <MessageCircle className="w-5 h-5 text-neon-green" />
        <h3 className="text-xl font-bold">Comments ({comments?.length || 0})</h3>
      </div>

      <CommentForm onSubmit={addComment} />
      
      {comments && comments.length > 0 ? (
        <CommentList comments={comments} />
      ) : (
        <div className="text-center text-gray-400 py-8">
          No comments yet. Be the first to comment!
        </div>
      )}
    </div>
  );
};